import React, { useEffect, useState } from "react"
import { useParams, useNavigate, Link } from "react-router-dom"
import { Card, CardContent } from "../../components/ui/card"
import { Badge } from "../../components/ui/badge"
import { Button } from "../../components/ui/button"
 
 
import {
  Calendar,
  Clock,
  ArrowLeft,
  BookOpen,
  Share2,
  Facebook,
  Twitter,
  Linkedin,
  Mail,
  ArrowRight,
} from "lucide-react"
import SEO from "../SEO"
 
export default function BlogDetailBlogDetailPage() {
  const { slug } = useParams()
  const navigate = useNavigate()
  const currentUrl = window.location.href;
 
 
  const [blog, setBlog] = useState(null)
  const [relatedBlogs, setRelatedBlogs] = useState([])
  const [latestBlogs, setLatestBlogs] = useState([])
  const [loading, setLoading] = useState(true)
 
  const API_BASE = "/wp-json/wp/v2"
 
useEffect(() => {
  const fetchBlogData = async () => {
    setLoading(true) // ✅ start loading
 
    try {
      const res = await fetch(`${API_BASE}/blogs?slug=${slug}&_embed`)
      const data = await res.json()
 
      if (!data || data.length === 0) {
        setBlog(null)
        return
      }
 
      const blogData = data[0]
      setBlog(blogData)
      // SEO data from Rank Math
      if (blogData.seo) blogData._seo = blogData.seo
 
      // Related blogs
      if (blogData.tags?.length > 0) {
        const tagId = blogData.tags[0]
        const relatedRes = await fetch(
          `${API_BASE}/blogs?tags=${tagId}&exclude=${blogData.id}&per_page=3&_embed`
        )
        setRelatedBlogs(await relatedRes.json())
      }
 
      // Latest blogs
      const latestRes = await fetch(`${API_BASE}/blogs?per_page=5&_embed`)
      setLatestBlogs(await latestRes.json())
 
    } catch (err) {
      console.error("Error fetching blog data:", err)
      setBlog(null)
    } finally {
      setLoading(false) // ✅ stop loading
    }
  }
 
  fetchBlogData()
}, [slug])
 
 
 
 
  // Social Share URLs
const shareOnFacebook = () => {
  window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`, "_blank");
}
 
const shareOnTwitter = () => {
  window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(currentUrl)}&text=${encodeURIComponent(blog.title.rendered)}`, "_blank");
}
 
const shareOnLinkedIn = () => {
  window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(currentUrl)}`, "_blank");
}
 
const shareOnEmail = () => {
  window.location.href = `mailto:?subject=${encodeURIComponent(blog.title.rendered)}&body=${encodeURIComponent(currentUrl)}`;
}
 
// For Mobile Native Share (Share2 Icon)
const shareNative = async () => {
  if (navigator.share) {
    await navigator.share({
      title: blog.title.rendered,
      url: currentUrl,
    });
  } else {
    alert("Sharing is not supported on this device.");
  }
}
 
 
  if (loading) {
    return (
       <div className="flex justify-center items-center py-24">
    <p className="text-gray-500 text-lg">Loading article...</p>
  </div>
)}
 
  if (!blog) {
    return (
      <div className="text-center py-20">
        <h1 className="text-3xl font-bold mb-4">404 - Blog Not Found</h1>
        <p className="text-gray-600 mb-6">
          The article you’re looking for doesn’t exist.
        </p>
        <Button onClick={() => navigate(-1)}>Go Back</Button>
      </div>
    )
  }
 
  // ✅ Safely extract the main image URL
  const imageUrl =
    (blog?._embedded?.["wp:featuredmedia"]?.[0]?.source_url ||
    blog?.yoast_head_json?.og_image?.[0]?.url ||
    null)?.replace(/\.(png|jpe?g|gif|bmp|tiff?)$/i, ".webp") ?? null

  const seo = blog?._seo || blog?.seo || {};
  const blogKeywords = blog?.acf?.key_words || "";
 
  return (
    <>
    <SEO
      title={seo.title || blog?.title?.rendered}
      description={seo.description}
      canonical={seo.canonical}
      robots={Array.isArray(seo.robots) ? seo.robots.join(", ") : seo.robots || "index, follow"}
      keywords={blogKeywords}
      ogTitle={seo.og_title}
      ogDescription={seo.og_description}
      ogImage={seo.og_image || seo.featured_image || imageUrl}
      twitterTitle={seo.twitter_title}
      twitterDescription={seo.twitter_description}
    />
    <div className="min-h-screen bg-white">
      <main>
        {/* Breadcrumb */}
        <section className="bg-gradient-to-r from-primary/10 to-primary/5 py-6">
          <div className="container px-4 mx-auto">
            <div className="max-w-7xl mx-auto">
              <button
                onClick={() => navigate(-1)}
                className="inline-flex items-center text-primary hover:text-primary/80 transition-colors mb-4"
              >
                <ArrowLeft className="w-4 h-4 mr-2" />
                Back
              </button>
            </div>
          </div>
        </section>
 
        {/* Main Content */}
        <section className="py-12 bg-white">
          <div className="container px-4 mx-auto">
            <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12">
              {/* Blog Content */}
              <article className="lg:col-span-8 blog-detail-cont">
                {/* <Badge className="mb-4">
                  {blog.categories?.[0]
                    ? `Category ID: ${blog.categories[0]}`
                    : "General"}
                </Badge> */}
 
                <h1
                  className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight"
                  dangerouslySetInnerHTML={{ __html: blog.title.rendered }}
                />
 
                <div className="flex flex-wrap items-center gap-6 text-gray-600 mb-6">
                  <div className="flex items-center gap-2">
                    <Calendar className="w-5 h-5 text-primary" />
                    <span>
                      {new Date(blog.date).toLocaleDateString("en-IN", {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                      })}
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Clock className="w-5 h-5 text-primary" />
                    <span>5 min read</span>
                  </div>
                </div>
 
                {/* Author */}
                {/* <div className="flex items-center gap-4 p-4 bg-gray-50 rounded-lg border border-gray-200">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-primary to-black flex items-center justify-center text-white font-bold text-lg">
                    {blog.yoast_head_json?.author
                      ? blog.yoast_head_json.author.charAt(0)
                      : "A"}
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">
                      {blog.yoast_head_json?.author || "Admin"}
                    </p>
                    <p className="text-sm text-gray-600">
                      {blog.author_role || "Medical Author"}
                    </p>
                  </div>
                </div> */}
 
                {/* Featured Image */}
                {imageUrl && (
                  <div className="relative h-192 rounded-lg overflow-hidden my-8">
                    <img
                      src={imageUrl}
                      alt={blog.title.rendered}
                      className="w-full h-full object-cover"
                    />
                  </div>
                )}
 
                {/* Blog Content */}
                <div
                  className="prose prose-lg max-w-none prose-headings:text-gray-900 prose-p:text-gray-700"
                  dangerouslySetInnerHTML={{ __html: blog.content.rendered }}
                />
 
                {/* Share Buttons */}
                <div className="mt-12 pt-8 border-t border-gray-200">
                  <h3 className="text-lg font-semibold mb-4">
                    Share this article
                  </h3>
                  <div className="flex flex-wrap gap-3">
                    <Button onClick={shareOnFacebook} variant="outline" size="sm" className="gap-2 bg-transparent">
                      <Facebook className="w-4 h-4" /> Facebook
                    </Button>
 
                    <Button onClick={shareOnTwitter} variant="outline" size="sm" className="gap-2 bg-transparent">
                      <Twitter className="w-4 h-4" /> Twitter
                    </Button>
 
                    <Button onClick={shareOnLinkedIn} variant="outline" size="sm" className="gap-2 bg-transparent">
                      <Linkedin className="w-4 h-4" /> LinkedIn
                    </Button>
 
                    <Button onClick={shareOnEmail} variant="outline" size="sm" className="gap-2 bg-transparent">
                      <Mail className="w-4 h-4" /> Email
                    </Button>
 
                    <Button onClick={shareNative} variant="outline" size="sm" className="gap-2 bg-transparent">
                      <Share2 className="w-4 h-4" /> More
                    </Button>
                  </div>
                </div>
 
                {/* CTA */}
                <div className="mt-12 bg-gradient-to-r relative bg-[#a52a2a] py-16 rounded-lg p-8 text-white">
                  <h3 className="text-2xl font-bold mb-4">
                    Need Medical Assistance?
                  </h3>
                  <p className="mb-6 text-white/90">
                    Our expert team is here to help. Schedule an appointment
                    with our specialists today.
                  </p>
                  <div className="flex flex-wrap gap-4">
                     <Button size="lg" variant="secondary" className="shadow-lg" asChild>
                      <Link to="/book-now">
                      Book an Appointment
                      <ArrowRight className="w-5 h-5 ml-2" />
                      </Link>
                    </Button>
                    <Button size="lg" variant="secondary" className="shadow-lg" asChild>
                    <Link to="/contact">
                      Contact Us
                      <ArrowRight className="w-5 h-5 ml-2" />
                    </Link>
                     </Button>
                  </div>
                </div>
              </article>
 
              {/* Sidebar */}
              <aside className="lg:col-span-4">
                <div className="sticky top-24 space-y-8">
                  <Card className="border-gray-200">
                    <CardContent className="p-6">
                      <h3 className="text-xl font-bold mb-6 flex items-center gap-2">
                        <BookOpen className="w-5 h-5 text-primary" /> Latest Articles
                      </h3>
                      <div className="space-y-6">
                        {latestBlogs.map((b) => {
                          const latestImage =
                            (b?._embedded?.["wp:featuredmedia"]?.[0]?.source_url ||
                            b?.yoast_head_json?.og_image?.[0]?.url ||
                            null)?.replace(/\.(png|jpe?g|gif|bmp|tiff?)$/i, ".webp") ?? null
                          return (
                            <Link key={b.id} to={`/blogs/${b.slug}`} className="block group">
                              <div className="flex gap-4">
                                <div className="w-20 h-20 bg-gray-100 rounded-lg flex-shrink-0 flex items-center justify-center overflow-hidden">
                                  {latestImage ? (
                                    <img
                                      src={latestImage}
                                      alt={b.title.rendered}
                                      className="w-full h-full object-cover"
                                    />
                                  ) : (
                                    <BookOpen className="w-8 h-8 text-primary/30" />
                                  )}
                                </div>
                                <div>
                                  <h4
                                    className="font-semibold text-sm text-gray-900 group-hover:text-primary"
                                    dangerouslySetInnerHTML={{ __html: b.title.rendered }}
                                  />
                                  <p className="text-xs text-gray-500">
                                    {new Date(b.date).toLocaleDateString("en-IN", {
                                      month: "short",
                                      day: "numeric",
                                    })}
                                  </p>
                                </div>
                              </div>
                            </Link>
                          )
                        })}
                      </div>
                    </CardContent>
                  </Card>
                </div>
              </aside>
            </div>
          </div>
        </section>
 
        {/* Related Articles */}
        {/* <section className="py-12 bg-gray-100">
          <div className="container px-4 mx-auto">
            <div className="max-w-7xl mx-auto text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold mb-4">
                Related Articles
              </h2>
              <p className="text-gray-600 max-w-2xl mx-auto">
                Continue reading more articles related to this topic.
              </p>
            </div>
 
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {relatedBlogs.map((blog, index) => {
                const relatedImage =
                  blog?._embedded?.["wp:featuredmedia"]?.[0]?.source_url ||
                  blog?.yoast_head_json?.og_image?.[0]?.url ||
                  null
 
                return (
                  <Card
                    key={index}
                    className="group cursor-pointer overflow-hidden transition-all hover:shadow-xl border-gray-200"
                  >
                    <CardContent className="p-0"> */}
                      {/* Featured image or fallback */}
                      {/* <div className="relative h-48 overflow-hidden">
                        {relatedImage ? (
                          <img
                            src={relatedImage}
                            alt={blog.title.rendered}
                            className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
                            loading="lazy"
                          />
                        ) : (
                          <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-gray-100 flex items-center justify-center">
                            <BookOpen className="w-16 h-16 text-primary/20" />
                          </div>
                        )}
                        <div className="absolute top-4 right-4">
                          <Badge className="bg-white text-primary border-primary">
                            {blog.category_name || "General"}
                          </Badge>
                        </div>
                      </div>
 
                      <div className="p-6">
                        <div className="flex items-center gap-2 mb-3 text-sm text-gray-600">
                          <Calendar className="w-4 h-4 text-primary" />
                          <span>
                            {new Date(blog.date).toLocaleDateString("en-IN", {
                              month: "short",
                              day: "numeric",
                            })}
                          </span>
                        </div>
                        <h3
                          className="font-bold text-gray-900 mb-3 line-clamp-2 text-lg group-hover:text-primary transition-colors"
                          dangerouslySetInnerHTML={{ __html: blog.title.rendered }}
                        />
                        <p
                          className="text-gray-600 text-sm mb-4 line-clamp-3"
                          dangerouslySetInnerHTML={{
                            __html: blog.excerpt?.rendered || "",
                          }}
                        />
                        <Link
                          to={`/blogs/${blog.slug}`}
                          className="inline-flex items-center text-primary font-medium hover:underline group"
                        >
                          Read More
                          <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
                        </Link>
                      </div>
                    </CardContent>
                  </Card>
                )
              })}
            </div>
 
            {relatedBlogs.length === 0 && (
              <div className="text-center py-12">
                <BookOpen className="w-16 h-16 text-gray-300 mx-auto mb-4" />
                <p className="text-gray-600 mb-4">No related articles found</p>
                <Link to="/blogs">
                  <Button variant="outline">Browse All Articles</Button>
                </Link>
              </div>
            )}
          </div>
        </section> */}
      </main>
    </div>
    </>
  )
}